import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import type { UseRefinementListProps } from 'react-instantsearch';
import { useRefinementList } from 'react-instantsearch';

import { Checkbox } from '@/components/Checkbox';
import { Flex } from '@/components/Flex';
import { useRegionProvider } from '@/providers/RegionProvider';
import type { ListingType } from '@/states/listingState';

import { useTransformStoreTypeLabel } from './helpers';

const filteredItems = (items: RefinementListItem[], attribute: string) => {
  switch (attribute) {
    case 'size': {
      const itemsWithLabelRounded = items.map((item) => {
        const integerPart = item.label.split('.')[0];
        return {
          ...item,
          label: integerPart,
        };
      });
      return itemsWithLabelRounded.sort((a, b) => {
        const aDiameter = Number(a.label.split(' ')[0]);
        const bDiameter = Number(b.label.split(' ')[0]);
        return aDiameter - bDiameter;
      });
    }
    default:
      return items;
  }
};

type TextualFilterOptionsProps = UseRefinementListProps & {
  forceNoLocale?: boolean;
  listing?: ListingType;
};

export const TextualFilterOptions = (props: TextualFilterOptionsProps) => {
  const { locale: regionLocale } = useRegionProvider();

  const { items, refine } = useRefinementList({
    ...props,
    attribute:
      props.forceNoLocale ||
      props.attribute == 'size' ||
      props.attribute == 'collection' ||
      props.attribute == 'distance_between_horns_en' ||
      (props.attribute == 'type' && props.listing === 'STORE')
        ? props.attribute
        : `${props.attribute}.${
            regionLocale?.code?.toUpperCase() || 'EN_GB' || 'EN_US'
          }`,
  });
  const results = useTransformStoreTypeLabel(
    filteredItems(items, props.attribute),
  );

  if (!results || results.length === 0) {
    return null;
  }

  const filterRefine = (value: string) => {
    refine(value);
  };

  return (
    <>
      <Flex
        alignItems='start'
        data-test-id='TextualFilterOptions'
        flexDirection='column'
        gridGap={2}
        justifyContent='start'
      >
        {results.map((item, index) => {
          return (
            <Checkbox
              key={item.label}
              checked={item.isRefined}
              data-testid={`TextualFilterCheckbox-${index}`}
              onClick={() => filterRefine(item.value)}
            >
              {item.label.replaceAll('_', ' ')} ({item.count})
            </Checkbox>
          );
        })}
      </Flex>
    </>
  );
};

TextualFilterOptions.displayName = 'TextualFilterOptions';
